














export default
  name: 'ErrorDialog'
  props:
    msg: {
      type: String
      required: true
    }
    dialog: {
      type: Boolean
      required: true
    }

  methods:
    onClose: () ->
      this.$emit('close', 'error')



// WEBPACK FOOTER //
// ./src/packages/dialogs/Error.vue